export default __webpack_public_path__ + "static/media/20.46462f3a.png";